<section class="vo-card" aria-labelledby="step3-title">
  <header class="vo-card__head">
    <h2 class="vo-card__title" id="step3-title">Zusatzleistungen</h2>
    <p class="vo-card__sub">Was sollen die Firmen zusätzlich übernehmen?</p>
  </header>

  <form class="vo-grid" [formGroup]="draftInquiryForm" novalidate>
    <div class="vo-field vo-field--full">
      <span class="vo-label" id="step3-services">
        Zusätzliche Services <span class="vo-label__optional">(optional)</span>
      </span>
      <div class="vo-options" role="group" aria-labelledby="step3-services">
        <button *ngFor="let service of additionalServices" type="button" class="vo-option"
                [class.is-selected]="isAdditionalServiceActive(service.value)"
                [attr.aria-pressed]="isAdditionalServiceActive(service.value)"
                (click)="toggleAdditionalService(service.value)">
          <span class="vo-box" aria-hidden="true"><app-icon name="check" [size]="13" [strokeWidth]="3.5"/></span>
          <span class="vo-option__body">
            <span class="vo-option__title">
              <app-icon [name]="service.lucideIcon" [size]="16"/>
              {{ service.label }}
            </span>
            <span class="vo-option__desc">{{ service.description }}</span>
          </span>
        </button>
      </div>
    </div>

    <div class="vo-field vo-field--full">
      <label class="vo-label" for="comment">
        Besondere Gegenstände / Bemerkungen <span class="vo-label__optional">(optional)</span>
      </label>
      <textarea id="comment" class="vo-textarea" rows="3" formControlName="comment"
                placeholder="z.B. Aquarium, wertvolle Kunstgegenstände, besondere Anforderungen …"></textarea>
    </div>
  </form>
</section>

<app-inquiry-step-nav (back)="goBack()" (next)="onSubmit()"/>
